<kt-portlet [class]="'kt-portlet--height-fluid'">
  <kt-portlet-header [title]="'Faq'">
    <ng-container ktPortletTools> </ng-container>
  </kt-portlet-header>

  <kt-portlet-body>
    <ngb-accordion [closeOthers]="true" activeIds="faq-0">
      <ngb-panel *ngFor="let item of faq$ | async; let idx = index" [id]="'faq-' + idx" [title]="getQuestion(item)">
        <ng-template ngbPanelContent>
          <div [innerHTML]="getAnswer(item)"></div>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>
  </kt-portlet-body>
</kt-portlet>
